<template>
  <v-container
    class="d-flex w-auto mx-md-33 py-md-12"
    v-bind="$attrs"
  >
    <TheNavigationDrawer
      class="d-none d-md-block pa-0 transparent mr-24"
    />
    <v-row class="transparent">
      <v-col
        cols="12"
        md="8"
        class="pa-0 pt-md-0"
      >
        <slot name="center-content" />
      </v-col>
      <v-col
        cols="0"
        md="4"
        class="px-0 d-none d-md-block px-md-0 ma-md-0 pt-md-0"
      >
        <slot name="right-content" />
      </v-col>
    </v-row>
    <TheNavBar class="d-flex d-md-none" v-if="!hideBottomNavBar"/>
  </v-container>
</template>

<script>
import TheNavigationDrawer from '@/components/TheNavigationDrawer.vue';
import TheNavBar from '@/components/TheNavBar.vue';

export default {
  components: {
    TheNavigationDrawer,
    TheNavBar,
  },
  props: {
    hideBottomNavBar: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.knots-illustration {
  position: absolute !important;
  z-index: 100;
  right: -85px;
  top: -110px;

  @media only screen and (min-width: 960px) {
    right: 80px !important;
    top: -50px !important;
  }
}
</style>
